export const products = [
  {
    "id": 1,
    "name": "Costume gris foncé à fines rayures",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-1.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-1.jpg",
      "/Images/costumes/costumes-g/costume-g-1-2.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 1
      },
      {
        "size": "58",
        "stock": 1
      },
      {
        "size": "60",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      }
    ]
  },
  {
    "id": 2,
    "name": "Costume marron à fines rayures",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-2.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-2.jpg"
    ],
    "description": "Costume marron chic avec fines rayures, parfait pour un look professionnel et sophistiqué.",
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 1
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 1
      },
      {
        "size": "60",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      }
    ]
  },
  {
    "id": 3,
    "name": "Costume noir à fines rayures",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-3.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-3.jpg"
    ],
    "description": "Sublimez votre tenue formelle avec ce costume noir à fines rayures distingué, élaboré avec expertise pour dégager sophistication. La coupe finement ajustée présente des revers crantés classiques et des épaules structurées, garantissant une silhouette raffinée pour toutes les occasions.",
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      }
    ]
  },
  {
    "id": 4,
    "name": "Costume gris noirâtre à fines rayures",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-4.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-4.jpg"
    ],
    "description": "Costume business classique, coupe droite, idéal pour les réunions et événements professionnels.",
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 1
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 5,
    "name": "Costume bleu marine à fines rayures",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-5.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-5.jpg"
    ],
    "description": "Adoptez un look professionnel avec ce costume business classique, conçu pour allier confort et élégance lors de vos journées de travail.",
    "category": "Costumes",
    "variants": [
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "46",
        "stock": 1
      },
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "50",
        "stock": 1
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 6,
    "name": "Costume Gris argent à fines rayures",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-6.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-6.jpg"
    ],
    "description": "Costume gris argent, coupe droite, idéal pour le travail et les occasions formelles.",
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 7,
    "name": "Costume Bleu Marine à fines rayures",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-7.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-7.jpg"
    ],
    "description": "Costume bleu marine sobre et moderne, parfait pour réunions, cérémonies et événements professionnels.",
    "category": "Costumes",
    "variants": [
      {
        "size": "46",
        "stock": 1
      },
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "52",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 8,
    "name": "Costume Beige Rayé",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-8.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-8.jpg"
    ],
    "description": "Costume beige à fines rayures, style distingué, adapté aux occasions chic et formelles.",
    "category": "Costumes",
    "variants": [
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 9,
    "name": "Costume à carreaux bleus - Style sophistiquée",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-9.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-9.jpg"
    ],
    "description": "Élevez votre garde-robe professionnelle avec notre costume élégant à carreaux bleus, conçu avec soin pour l'homme exigeant. Ce costume présente un motif à carreaux sophistiqué qui combine harmonieusement styles classique et contemporain, garantissant une impression durable en toute occasion.",
    "category": "Costumes",
    "variants": [
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "50",
        "stock": 1
      },
      {
        "size": "52",
        "stock": 1
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 10,
    "name": "Costume noir classique",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-10.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-10.jpg"
    ],
    "description": "Costume noir sobre et moderne, parfait pour réunions, cérémonies et événements professionnels.",
    "category": "Costumes",
    "variants": [
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 11,
    "name": "Costume bleu classique",
    "price": 85000,
    "originalPrice": 95000,
    "image": "/Images/costumes/costumes-g/costume-g-11.jpg",
    "images": [
      "/Images/costumes/costumes-g/costume-g-11.jpg"
    ],
    "description": "Costume bleu nu classique et moderne, parfait pour réunions, cérémonies et événements professionnels.",
    "category": "Costumes",
    "variants": [
      {
        "size": "46",
        "stock": 1
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 12,
    "name": "Costume homme gris uni coupe slim, deux boutons 100% laine",
    "price": 75000,
    "originalPrice": 85000,
    "image": "/Images/costumes/costumes-gp/costume-gp-1.jpg",
    "images": [
      "/Images/costumes/costumes-gp/costume-gp-1.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 13,
    "name": "Costume homme bleu marine uni coupe slim, deux boutons",
    "price": 75000,
    "originalPrice": 85000,
    "image": "/Images/costumes/costumes-gp/costume-gp-2.jpg",
    "images": [
      "/Images/costumes/costumes-gp/costume-gp-2.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 14,
    "name": "Costume homme marron uni coupe slim, deux boutons",
    "price": 75000,
    "originalPrice": 85000,
    "image": "/Images/costumes/costumes-gp/costume-gp-3.jpg",
    "images": [
      "/Images/costumes/costumes-gp/costume-gp-3.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 15,
    "name": "Costume homme gris uni coupe slim, deux boutons 100% laine",
    "price": 75000,
    "originalPrice": 85000,
    "image": "/Images/costumes/costumes-gp/costume-gp-4.jpg",
    "images": [
      "/Images/costumes/costumes-gp/costume-gp-4.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "50",
        "stock": 2
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "58",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 16,
    "name": "Costume homme beige uni coupe slim, deux boutons 100% laine",
    "price": 75000,
    "originalPrice": 85000,
    "image": "/Images/costumes/costumes-gp/costume-gp-5.jpg",
    "images": [
      "/Images/costumes/costumes-gp/costume-gp-5.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 17,
    "name": "Costume homme bleu marine uni coupe slim, deux boutons, 100% laine",
    "price": 75000,
    "originalPrice": 85000,
    "image": "/Images/costumes/costumes-gp/costume-gp-6.jpg",
    "images": [
      "/Images/costumes/costumes-gp/costume-gp-6.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 1
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 18,
    "name": "Costume homme bleu marine uni coupe slim, deux boutons, 100% laine",
    "price": 75000,
    "originalPrice": 85000,
    "image": "/Images/costumes/costumes-gp/costume-gp-7.jpg",
    "images": [
      "/Images/costumes/costumes-gp/costume-gp-7.jpg"
    ],
    "category": "Costumes",
    "variants": [
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 19,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-1.jpg",
    "images": [
      "/Images/blazers/blazers-1.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 20,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-2.jpg",
    "images": [
      "/Images/blazers/blazers-2.jpg"
    ],
    "category": "Blazers",
    "customStatus": "Out Of Stock",
    "variants": [
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 21,
    "name": "Blazer Business",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-3.jpg",
    "images": [
      "/Images/blazers/blazers-3.jpg"
    ],
    "category": "Blazers",
    "customStatus": "Out Of Stock",
    "variants": [
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 22,
    "name": "Blazer Moderne",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-4.jpg",
    "images": [
      "/Images/blazers/blazers-4.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "50",
        "stock": 1
      },
      {
        "size": "52",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 23,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-5.jpg",
    "images": [
      "/Images/blazers/blazers-5.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 24,
    "name": "Blazer Formel",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-6.jpg",
    "images": [
      "/Images/blazers/blazers-6.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "58",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 1
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 25,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-7.jpg",
    "images": [
      "/Images/blazers/blazers-7.jpg"
    ],
    "category": "Blazers",
    "customStatus": "Out Of Stock",
    "variants": [
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 26,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-8.jpg",
    "images": [
      "/Images/blazers/blazers-8.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "56",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 27,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-9.jpg",
    "images": [
      "/Images/blazers/blazers-9.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "50",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "54",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 28,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-10.jpg",
    "images": [
      "/Images/blazers/blazers-10.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "46",
        "stock": 1
      },
      {
        "size": "48",
        "stock": 1
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 29,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-11.jpg",
    "images": [
      "/Images/blazers/blazers-11.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "52",
        "stock": 1
      },
      {
        "size": "54",
        "stock": 1
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
  {
    "id": 30,
    "name": "Blazer Classique",
    "price": 40000,
    "originalPrice": 45000,
    "image": "/Images/blazers/blazers-12.jpg",
    "images": [
      "/Images/blazers/blazers-12.jpg"
    ],
    "category": "Blazers",
    "variants": [
      {
        "size": "54",
        "stock": 2
      },
      {
        "size": "56",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      },
      {
        "size": "48",
        "stock": 0
      },
      {
        "size": "50",
        "stock": 0
      },
      {
        "size": "52",
        "stock": 0
      },
      {
        "size": "58",
        "stock": 0
      },
      {
        "size": "60",
        "stock": 0
      }
    ]
  },
   {
    "id": 31,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage1.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 32,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage2.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 33,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage3.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 34,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage4.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 35,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage5.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 36,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage6.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 37,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage7.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 38,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage8.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 39,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage9.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 40,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage10.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 41,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage11.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 42,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage12.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 43,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage13.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 44,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage14.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
   {
    "id": 45,
    "name": "Chemise premium made in turkey",
    "price": 22000,
    "image": "/Images/chemises/nouvelarrivage/nouvelarrivage15.jpg",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "L",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 2
      },
      {
        "size": "XXL",
        "stock": 2
      },
    ]
  },
  {
    "id": 46,
    "name": "Chemise Bleue ciel Business",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-1.jpg",
    "images": [
      "/Images/chemises/chemise-1.jpg"
    ],
    "customStatus": "Out Of Stock",
    "category": "Chemises",
    "variants": [
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ]
  },
  {
    "id": 87,
    "name": "Chemise Blanche Classique",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-2.jpg",
    "images": [
      "/Images/chemises/chemise-2.jpg"
    ],
    "customStatus": "Out Of Stock",
    "category": "Chemises",
    "isNew": true,
    "variants": [
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ]
  },
  {
    "id": 88,
    "name": "Chemise Bleue ciel Business",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-3.jpg",
    "images": [
      "/Images/chemises/chemise-3.jpg"
    ],
    "variants": [
      {
        "size": "2XL",
        "stock": 0
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 89,
    "name": "Chemise Blanche Classique",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-4.jpg",
    "images": [
      "/Images/chemises/chemise-4.jpg"
    ],
    "customStatus": "Out Of Stock",
    "category": "Chemises",
    "variants": [
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ]
  },
  {
    "id": 90,
    "name": "Chemise Blanche Classique, Slim Fit",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-5.jpg",
    "images": [
      "/Images/chemises/chemise-5.jpg"
    ],
    "variants": [
      {
        "size": "2XL",
        "stock": 0
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 91,
    "name": "Chemise Premium",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-6.jpg",
    "images": [
      "/Images/chemises/chemise-6.jpg"
    ],
    "variants": [
      {
        "size": "S",
        "stock": 1
      },
      {
        "size": "M",
        "stock": 1
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 92,
    "name": "Chemise Premium",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-7.jpg",
    "images": [
      "/Images/chemises/chemise-7.jpg"
    ],
    "variants": [
      {
        "size": "M",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 3
      },
      {
        "size": "2XL",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 93,
    "name": "Chemise Premium",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-8.jpg",
    "images": [
      "/Images/chemises/chemise-8.jpg"
    ],
    "variants": [
      {
        "size": "M",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 94,
    "name": "Chemise Premium",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-9.jpg",
    "images": [
      "/Images/chemises/chemise-9.jpg"
    ],
    "variants": [
      {
        "size": "S",
        "stock": 2
      },
      {
        "size": "XL",
        "stock": 3
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 95,
    "name": "Chemise Premium",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-10.jpg",
    "images": [
      "/Images/chemises/chemise-10.jpg"
    ],
    "variants": [
      {
        "size": "M",
        "stock": 1
      },
      {
        "size": "L",
        "stock": 1
      },
      {
        "size": "XL",
        "stock": 1
      },
      {
        "size": "2XL",
        "stock": 2
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 96,
    "name": "Chemise Premium",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-11.jpg",
    "images": [
      "/Images/chemises/chemise-11.jpg"
    ],
    "variants": [
      {
        "size": "M",
        "stock": 1
      },
      {
        "size": "XL",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 97,
    "name": "Chemise Premium",
    "price": 16000,
    "originalPrice": 18000,
    "image": "/Images/chemises/chemise-12.jpg",
    "images": [
      "/Images/chemises/chemise-12.jpg"
    ],
    "variants": [
      {
        "size": "2XL",
        "stock": 0
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "Chemises"
  },
  {
    "id": 98,
    "name": "Marco Cassetti Exclusive",
    "price": 60000,
    "image": "/Images/chaussures/souliers/marco_casseti/marco_casseti_1.jpg",
    "images": [
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_1.jpg",
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_1_2.jpg"
    ],
    "variants": [
      {
        "color": "#531702",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "45",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "42",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "45",
        "stock": 0
      },
    ],
    "description": "Sublimez votre collection de chaussures avec la chaussure habillée exclusive Marco Cassetti, un modèle d'exception alliant savoir-faire et raffinement. Conçue pour l'homme élégant et exigeant, cette chaussure marie avec modernité l'élégance classique.",
    "category": "Chaussures"
  },
  {
    "id": 99,
    "name": "Marco Cassetti Exclusive",
    "price": 60000,
    "image": "/Images/chaussures/souliers/marco_casseti/marco_casseti_2.jpg",
    "images": [
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_2.jpg"
    ],
    "variants": [
      {
        "color": "#000000",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "43",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "44",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "45",
        "stock": 0
      },
    ],
    "description": "Sublimez votre collection de chaussures avec la chaussure habillée exclusive Marco Cassetti, un modèle d'exception alliant savoir-faire et raffinement. Conçue pour l'homme élégant et exigeant, cette chaussure marie avec modernité l'élégance classique.",
    "category": "Chaussures"
  },
  {
    "id": 100,
    "name": "Marco Cassetti Exclusive",
    "price": 60000,
    "image": "/Images/chaussures/souliers/marco_casseti/marco_casseti_3.jpg",
    "images": [
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_3.jpg"
    ],
    "variants": [
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "45",
        "stock": 1
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      }
    ],
    "description": "Sublimez votre collection de chaussures avec la chaussure habillée exclusive Marco Cassetti, un modèle d'exception alliant savoir-faire et raffinement. Conçue pour l'homme élégant et exigeant, cette chaussure marie avec modernité l'élégance classique.",
    "category": "Chaussures"
  },
  {
    "id": 101,
    "name": "Marco Cassetti Exclusive",
    "price": 60000,
    "image": "/Images/chaussures/souliers/marco_casseti/marco_casseti_4.jpg",
    "images": [
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_4.jpg"
    ],
    "variants": [
      {
        "size": "40",
        "stock": 1
      },
      {
        "size": "41",
        "stock": 1
      },
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "description": "Sublimez votre collection de chaussures avec la chaussure habillée exclusive Marco Cassetti, un modèle d'exception alliant savoir-faire et raffinement. Conçue pour l'homme élégant et exigeant, cette chaussure marie avec modernité l'élégance classique.",
    "category": "Chaussures"
  },
  {
    "id": 47,
    "name": "Marco Cassetti Exclusive",
    "price": 60000,
    "image": "/Images/chaussures/souliers/marco_casseti/marco_casseti_5.jpg",
    "images": [
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_5.jpg"
    ],
    "variants": [
      {
        "size": "41",
        "stock": 1
      },
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "43",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "description": "Sublimez votre collection de chaussures avec la chaussure habillée exclusive Marco Cassetti, un modèle d'exception alliant savoir-faire et raffinement. Conçue pour l'homme élégant et exigeant, cette chaussure marie avec modernité l'élégance classique.",
    "category": "Chaussures"
  },
  {
    "id": 48,
    "name": "Marco Cassetti Exclusive",
    "price": 60000,
    "image": "/Images/chaussures/souliers/marco_casseti/marco_casseti_6.jpg",
    "images": [
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_6.jpg"
    ],
    "variants": [
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "45",
        "stock": 2
      },
      {
        "size": "43",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      }
    ],
    "description": "Sublimez votre collection de chaussures avec la chaussure habillée exclusive Marco Cassetti, un modèle d'exception alliant savoir-faire et raffinement. Conçue pour l'homme élégant et exigeant, cette chaussure marie avec modernité l'élégance classique.",
    "category": "Chaussures"
  },
  {
    "id": 49,
    "name": "Marco Cassetti Exclusive",
    "price": 60000,
    "image": "/Images/chaussures/souliers/marco_casseti/marco_casseti_7.jpg",
    "images": [
      "/Images/chaussures/souliers/marco_casseti/marco_casseti_7.jpg"
    ],
    "variants": [
      {
        "color": "#531702",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "45",
        "stock": 1
      },
      {
        "color": "#04043c",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#04043c",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#04043c",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#04043c",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#04043c",
        "size": "44",
        "stock": 1
      },
      {
        "color": "#04043c",
        "size": "45",
        "stock": 1
      },
      {
        "size": "40",
        "stock": 0
      }
    ],
    "description": "Sublimez votre collection de chaussures avec la chaussure habillée exclusive Marco Cassetti, un modèle d'exception alliant savoir-faire et raffinement. Conçue pour l'homme élégant et exigeant, cette chaussure marie avec modernité l'élégance classique.",
    "category": "Chaussures"
  },
  {
    "id": 50,
    "name": "Soulier Luxe, King Class",
    "price": 50000,
    "image": "/Images/chaussures/souliers/class_king/class_king_1.jpg",
    "images": [
      "/Images/chaussures/souliers/class_king/class_king_1.jpg",
      "/Images/chaussures/souliers/class_king/class_king_1_2.jpg"
    ],
    "variants": [
      {
        "color": "#531702",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "46",
        "stock": 1
      },

      {
        "color": "#000000",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "43",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "46",
        "stock": 0
      },
    ],
    "category": "Chaussures"
  },
  {
    "id": 51,
    "name": "Soulier Luxe, King Class",
    "price": 50000,
    "image": "/Images/chaussures/souliers/class_king/class_king_2.jpg",
    "variants": [
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 52,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-1.jpg",
    "variants": [
      {
        "color": "#c1fdffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#0007e1ff",
        "size": "M",
        "stock": 0
      },
      {
        "color": "#0007e1ff",
        "size": "XL",
        "stock": 0
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 53,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-2.jpg",
    "variants": [
      {
        "color": "#e70b0bff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#765227ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#765227ff",
        "size": "XL",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 54,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-3.jpg",
    "variants": [
      {
        "color": "#ffffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#010101",
        "size": "M",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 55,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-4.jpg",
    "variants": [
      {
        "color": "#ffffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#010101",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#010101",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#060153ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#060153ff",
        "size": "L",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 56,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-5.jpg",
    "variants": [
      {
        "color": "#f1de10ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "XL",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 57,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-6.jpg",
    "variants": [
      {
        "color": "#ffffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#010101",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "M",
        "stock": 2
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 58,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-7.jpg",
    "variants": [
      {
        "color": "#040124ff",
        "size": "M",
        "stock": 0
      },
      {
        "color": "#040124ff",
        "size": "L",
        "stock": 0
      },
      {
        "color": "#040124ff",
        "size": "XL",
        "stock": 0
      },
      {
        "color": "#040124ff",
        "size": "2XL",
        "stock": 0
      },
      {
        "color": "#ffffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#070794ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#070794ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "XL",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 59,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-8.jpg",
    "variants": [
      {
        "color": "#ffffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#040124ff",
        "customStatus": "Out Of Stock"
      },
      {
        "color": "#f1de10ff",
        "customStatus": "Out Of Stock"
      },
      {
        "color": "#070794ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#070794ff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#938effff",
        "customStatus": "Out Of Stock"
      },
      {
        "color": "#765227ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#765227ff",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#6b7a4a",
        "customStatus": "Out Of Stock"
      },
      {
        "color": "#360404ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#010101",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#010101",
        "size": "L",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 60,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-9.jpg",
    "variants": [
      {
        "color": "#ffffff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#ffffff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#040124ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#040124ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#e70b0bff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#070794ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#070794ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#360404ff",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#010101",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#6b7a4a",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#6b7a4a",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#f1de10ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#f1de10ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#f1de10ff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#938effff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#938effff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#938effff",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#765227ff",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#765227ff",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#765227ff",
        "size": "XL",
        "stock": 2
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      },
      {
        "size": "3XL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 61,
    "name": "T-shirt Polo Sport",
    "price": 13000,
    "originalPrice": 14000,
    "image": "/Images/polo/tshirts/tshirts-10.jpg",
    "variants": [
      {
        "color": "#FFFFFF",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#FFFFFF",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#FFFFFF",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#FFFFFF",
        "size": "5XL",
        "stock": 1
      },
      {
        "color": "#6b1f2a",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#6b1f2a",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#244726",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#244726",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#02066b",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#010341",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#010341",
        "size": "5XL",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "M",
        "stock": 0
      },
      {
        "size": "L",
        "stock": 0
      },
      {
        "size": "XL",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 62,
    "name": "T-shirt Polo Manche Longue",
    "price": 17000,
    "originalPrice": 20000,
    "image": "/Images/polo/manches_longues/manches_longues-1.jpg",
    "images": [
      "/Images/polo/manches_longues/manches_longues-1.jpg",
      "/Images/polo/manches_longues/manches_longues-1-2.jpg"
    ],
    "variants": [
      {
        "color": "#ffead0",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#ffead0",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#3e301f",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#3e301f",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#3e301f",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#3e301f",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#3e301f",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#3e301f",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#060d93",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#060d93",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#060d93",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#060d93",
        "size": "2XL",
        "stock": 2
      },
      {
        "color": "#060d93",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#060d93",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#060d93",
        "size": "5XL",
        "stock": 1
      },
      {
        "color": "#959494",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#959494",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#959494",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#959494",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#959494",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#1a1a1a",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#1a1a1a",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#1a1a1a",
        "size": "2XL",
        "stock": 2
      },
      {
        "color": "#1a1a1a",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#1a1a1a",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#1a1a1a",
        "size": "5XL",
        "stock": 1
      },
      {
        "color": "#6b1f2a",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#6b1f2a",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#6b1f2a",
        "size": "2XL",
        "stock": 2
      },
      {
        "color": "#6b1f2a",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#6b1f2a",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#6b1f2a",
        "size": "5XL",
        "stock": 1
      },
      {
        "color": "#b37a3c",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#b37a3c",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#b37a3c",
        "size": "XL",
        "stock": 1
      },
      {
        "color": "#b37a3c",
        "size": "2XL",
        "stock": 2
      },
      {
        "color": "#b37a3c",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#b37a3c",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#07014e",
        "size": "M",
        "stock": 1
      },
      {
        "color": "#07014e",
        "size": "L",
        "stock": 1
      },
      {
        "color": "#07014e",
        "size": "2XL",
        "stock": 2
      },
      {
        "color": "#07014e",
        "size": "3XL",
        "stock": 1
      },
      {
        "color": "#07014e",
        "size": "4XL",
        "stock": 1
      },
      {
        "color": "#07014e",
        "size": "5XL",
        "stock": 1
      },
      {
        "color": "#6b7a4a",
        "size": "2XL",
        "stock": 1
      },
      {
        "color": "#6b7a4a",
        "size": "4XL",
        "stock": 2
      },
      {
        "color": "#6b7a4a",
        "size": "5XL",
        "stock": 1
      },
      {
        "size": "S",
        "stock": 0
      },
      {
        "size": "XXL",
        "stock": 0
      }
    ],
    "category": "T-shirt-Polo"
  },
  {
    "id": 63,
    "name": "Mocassins élégants en cuir noir pour homme",
    "price": 40000,
    "image": "/Images/chaussures/mocassins/ozbek/ozbek-1.jpg",
    "images": [
      "/Images/chaussures/mocassins/ozbek/ozbek-1.jpg",
      "/Images/chaussures/mocassins/ozbek/ozbek-2.jpg"
    ],
    "variants": [
      {
        "color": "#531702",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 3
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "41",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "43",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "description": "Sublimez votre collection de chaussures avec nos mocassins élégants en cuir noir pour homme, conçus pour allier sophistication et confort.",
    "category": "Chaussures"
  },
  {
    "id": 64,
    "name": "Mocassins Premium en cuir naturel",
    "price": 40000,
    "image": "/Images/chaussures/mocassins/abo_alward/abo_alward-1.jpg",
    "images": [
      "/Images/chaussures/mocassins/abo_alward/abo_alward-1.jpg",
      "/Images/chaussures/mocassins/abo_alward/abo_alward-2.jpg"
    ],
    "variants": [
      {
        "color": "#531702",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#000080",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#000080",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#000080",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#000080",
        "size": "43",
        "stock": 0
      },
      {
        "color": "#000080",
        "size": "44",
        "stock": 0
      },
      
    ],
    "description": "Sublimez votre collection de chaussures avec nos mocassins élégants en cuir naturel pour homme, conçus pour allier sophistication et confort.",
    "category": "Chaussures"
  },
  {
    "id": 65,
    "name": "Mocassins léger",
    "price": 40000,
    "image": "/Images/chaussures/mocassins/pierre_cardin/pierre_cardin.jpg",
    "images": [
      "/Images/chaussures/mocassins/pierre_cardin/pierre_cardin.jpg"
    ],
    "variants": [
      {
        "color": "#000000",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "41",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "42",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "44",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 1
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "description": "Sublimez votre collection de chaussures avec nos mocassins élégants en cuir naturel pour homme, conçus pour allier sophistication et confort.",
    "category": "Chaussures"
  },
  {
    "id": 66,
    "name": "Mocassin Simple en cuir noir",
    "price": 25000,
    "image": "/Images/chaussures/mocassins/simple/simple-1.jpg",
    "images": [
      "/Images/chaussures/mocassins/simple/simple-1.jpg"
    ],
    "variants": [
      {
        "size": "41",
        "stock": 1
      },
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "43",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 67,
    "name": "Mocassin Simple en cuir marron",
    "price": 25000,
    "image": "/Images/chaussures/mocassins/simple/simple-2.jpg",
    "images": [
      "/Images/chaussures/mocassins/simple/simple-2.jpg"
    ],
    "variants": [
      {
        "size": "40",
        "stock": 1
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 68,
    "name": "Mocassin Simple en cuir bleu marine",
    "price": 25000,
    "image": "/Images/chaussures/mocassins/simple/simple-3.jpg",
    "images": [
      "/Images/chaussures/mocassins/simple/simple-3.jpg"
    ],
    "variants": [
      {
        "size": "40",
        "stock": 1
      },
      {
        "size": "41",
        "stock": 1
      },
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "43",
        "stock": 2
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 69,
    "name": "Mocassins Simple, cuir naturel",
    "price": 25000,
    "image": "/Images/chaussures/mocassins/simple/simple-4.jpg",
    "images": [
      "/Images/chaussures/mocassins/simple/simple-4.jpg"
    ],
    "variants": [
      {
        "color": "#311c02",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#311c02",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#311c02",
        "size": "42",
        "stock": 0
      },
      {
        "color": "#311c02",
        "size": "43",
        "stock": 1
      },
      {
        "color": "#311c02",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#311c02",
        "size": "45",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 70,
    "name": "Mocassins Simple, cuir naturel",
    "price": 25000,
    "image": "/Images/chaussures/mocassins/simple/simple-5.jpg",
    "images": [
      "/Images/chaussures/mocassins/simple/simple-5.jpg"
    ],
    "variants": [
      {
        "color": "#b37a3c",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#b37a3c",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#b37a3c",
        "size": "42",
        "stock": 2
      },
      {
        "color": "#b37a3c",
        "size": "43",
        "stock": 1
      },
      {
        "color": "#b37a3c",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#b37a3c",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#1a1a1a",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#1a1a1a",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#1a1a1a",
        "size": "42",
        "stock": 0
      },
      {
        "color": "#1a1a1a",
        "size": "43",
        "stock": 0
      },
      {
        "color": "#1a1a1a",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#1a1a1a",
        "size": "45",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 71,
    "name": "Mocassins Simple, cuir naturel",
    "price": 25000,
    "image": "/Images/chaussures/mocassins/simple/simple-6.jpg",
    "images": [
      "/Images/chaussures/mocassins/simple/simple-6.jpg"
    ],
    "variants": [
      {
        "size": "40",
        "stock": 1
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "43",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 72,
    "name": "Sneakers Classiques",
    "price": 50000,
    "image": "/Images/chaussures/sneakers/derimod/derimod-1.jpg",
    "images": [
      "/Images/chaussures/sneakers/derimod/derimod-1.jpg",
      "/Images/chaussures/sneakers/derimod/derimod-2.jpg"
    ],
    "variants": [
      {
        "color": "#531702",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "46",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "40",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "41",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "42",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "43",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "44",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "46",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 73,
    "name": "Sneakers Classiques",
    "price": 45000,
    "image": "/Images/chaussures/sneakers/derimod-v/derimod-v-1.jpg",
    "variants": [
      {
        "size": "40",
        "stock": 1
      },
      {
        "size": "41",
        "stock": 2
      },
      {
        "size": "42",
        "stock": 2
      },
      {
        "size": "43",
        "stock": 2
      },
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "45",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 74,
    "name": "Sneakers Premium",
    "price": 40000,
    "image": "/Images/chaussures/sneakers/kemal_tanka/kemal_tanka-1.jpg",
    "images": [
      "/Images/chaussures/sneakers/kemal_tanka/kemal_tanka-1.jpg",
      "/Images/chaussures/sneakers/kemal_tanka/kemal_tanka-2.jpg"
    ],
    "variants": [
      {
        "color": "#000000",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "41",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "42",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#000000",
        "size": "44",
        "stock": 1
      },
      {
        "color": "#000000",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#000000",
        "size": "46",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "40",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "41",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "42",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "43",
        "stock": 2
      },
      {
        "color": "#531702",
        "size": "44",
        "stock": 1
      },
      {
        "color": "#531702",
        "size": "45",
        "stock": 0
      },
      {
        "color": "#531702",
        "size": "46",
        "stock": 0
      }
    ],
    "category": "Chaussures"
  },
  {
    "id": 75,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-1.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-1.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 1
      },
      {
        "size": "42",
        "stock": 1
      },
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "45",
        "stock": 1
      },
      {
        "size": "46",
        "stock": 2
      }
    ]
  },
  {
    "id": 76,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-2.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-2.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "46",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ]
  },
  {
    "id": 77,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-3.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-3.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "41",
        "stock": 1
      },
      {
        "size": "42",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 2
      },
      {
        "size": "45",
        "stock": 2
      },
      {
        "size": "46",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "43",
        "stock": 0
      }
    ]
  },
  {
    "id": 78,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-4.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-4.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "44",
        "stock": 2
      },
      {
        "size": "45",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "43",
        "stock": 0
      }
    ]
  },
  {
    "id": 79,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-5.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-5.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 2
      },
      {
        "size": "45",
        "stock": 2
      },
      {
        "size": "46",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      }
    ]
  },
  {
    "id": 80,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-6.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-6.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "45",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      }
    ]
  },
  {
    "id": 81,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-7.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-7.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "46",
        "stock": 1
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ]
  },
  {
    "id": 82,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-8.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-8.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "45",
        "stock": 2
      },
      {
        "size": "46",
        "stock": 1
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      }
    ]
  },
  {
    "id": 83,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-9.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-9.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 2
      },
      {
        "size": "46",
        "stock": 1
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ]
  },
  {
    "id": 84,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-10.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-10.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "43",
        "stock": 1
      },
      {
        "size": "44",
        "stock": 1
      },
      {
        "size": "46",
        "stock": 2
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "45",
        "stock": 0
      }
    ]
  },
  {
    "id": 85,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-11.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-11.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 1
      },
      {
        "size": "42",
        "stock": 1
      },
      {
        "size": "43",
        "stock": 2
      },
      {
        "size": "44",
        "stock": 2
      },
      {
        "size": "45",
        "stock": 2
      },
      {
        "size": "46",
        "stock": 2
      }
    ]
  },
  {
    "id": 86,
    "name": "Nue Pied en cuir naturel",
    "price": 30000,
    "image": "/Images/chaussures/nue-pieds/nue-pied-12.jpg",
    "images": [
      "/Images/chaussures/nue-pieds/nue-pied-12.jpg"
    ],
    "category": "Chaussures",
    "variants": [
      {
        "size": "43",
        "stock": 0
      },
      {
        "size": "44",
        "stock": 2
      },
      {
        "size": "45",
        "stock": 0
      },
      {
        "size": "40",
        "stock": 0
      },
      {
        "size": "41",
        "stock": 0
      },
      {
        "size": "42",
        "stock": 0
      },
      {
        "size": "46",
        "stock": 0
      }
    ]
  }
];

